export const isBetPortal = hasScope => {
  /* copied from https://git.hubteam.com/HubSpot/CRM/blob/master/crm_data/static-4.86317/js/BET/permissions/DealPermissions.js#L17
   * if a portal has this scope, it's a BET portal
   */
  return hasScope('bet-enforce-deal-stage-restrictions');
};